import '../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import Glide from '@glidejs/glide'

const footerCarousel = {
  el: '',
  init() {
    this.el = $q('.footer-carousel.glide')

    if (!this.el.first) return

    new Glide(this.el.first, {
      type: 'carousel',
      perView: 3,
      gap: 0,
      peek: {
        before: 0,
        after: 125
      }
    }).mount()
  }
}

export default footerCarousel
